module.exports = __webpack_public_path__ + "img/keypoints_guide_blackheads_icon.a394e37f.png";